import React from 'react';
import giraClient from '@atlassian/jira-apollo-gira';
import { ApolloClientProvider } from '@atlassian/jira-apollo-multiple-clients/src/main.tsx';
import DeploymentDetailsDialogWithoutApolloProvider, { type Props } from './ui';

const DeploymentDetailsDialog = (props: Props) => (
	<ApolloClientProvider client={giraClient}>
		<DeploymentDetailsDialogWithoutApolloProvider {...props} />
	</ApolloClientProvider>
);

export default DeploymentDetailsDialog;
